// extracted by mini-css-extract-plugin
export default {"container":"container--q0T1I","badgeContainer":"badgeContainer--_Pi8K","badgeContainerAsChild":"badgeContainerAsChild--b4TLn","badgeText":"badgeText--AprDR"};